import loc_en_strings from '@/resources/en.js';
import loc_de_strings from '@/resources/de.js';
import loc_bg_strings from '@/resources/bg.js';
import loc_nl_strings from '@/resources/nl.js';
import loc_fr_strings from '@/resources/fr.js';
import loc_it_strings from '@/resources/it.js';
import loc_ru_strings from '@/resources/ru.js';
import loc_sl_strings from '@/resources/sl.js';
import loc_es_strings from '@/resources/es.js';
import loc_cs_strings from '@/resources/cs.js';
import loc_pl_strings from '@/resources/pl.js';

export default function getStringsForLocale (loc) {
  switch (loc) {
    case "DE": return loc_de_strings;
    case "EN": return loc_en_strings;
    case "BG": return loc_bg_strings;
    case "NL": return loc_nl_strings;
    case "FR": return loc_fr_strings;
    case "IT": return loc_it_strings;
    case "RU": return loc_ru_strings;
    case "SL": return loc_sl_strings;
    case "ES": return loc_es_strings;
    case "CS": return loc_cs_strings;
    case "PL": return loc_pl_strings;
  }
  return loc_en_strings;
}



// WEBPACK FOOTER //
// ./src/resources/translations.js